import DateUtils from '@/utils/DateUtils';
import { tableOptionsToFirstPage } from '@/store/modules/StateUtil';

export const plannedServiceIndexState = {
    namespaced: true,
    state: {
        dateRange: {
            startDate: DateUtils.toLocalISOdate(DateUtils.toStartOfMonth(new Date())),
            endDate: DateUtils.toLocalISOdate(DateUtils.plusMonths(DateUtils.toStartOfMonth(new Date()),3)),
        },
        filterText: null,
        filterDeviceId: null,
        tableOptions: {
            page: 1,
            itemsPerPage: 30,
            sortBy: ['scheduleDate'],
            sortDesc: [false],
            mustSort: true,
            multiSort: false,
        },
    },
    mutations: {
        setDateRange(state, dateRange) {
            state.dateRange = dateRange;
            state.tableOptions = tableOptionsToFirstPage(state);
        },
        setOnlyCurrentUserAssigned(state, onlyCurrentUserAssigned) {
            state.onlyCurrentUserAssigned = onlyCurrentUserAssigned;
            state.tableOptions = tableOptionsToFirstPage(state);
        },
        setFilterText(state, filterText) {
            state.filterText = filterText;
            state.tableOptions = tableOptionsToFirstPage(state);
        },
        setFilterDeviceId(state, filterDeviceId) {
            state.filterDeviceId = filterDeviceId;
            state.tableOptions = tableOptionsToFirstPage(state);
        },
        setTableOptions(state, tableOptions) {
            state.tableOptions = tableOptions;
        },
    },
    getters: {
        dateRange: state => {
            return state.dateRange;
        },
        onlyCurrentUserAssigned: state => {
            return state.filterDeviceId;
        },
        filterText: state => {
            return state.filterText;
        },
        tableOptions: state => {
            return state.tableOptions;
        },
    },
};
